export default function ContactUs() {
  return <a href="mailto:support@optiwatt.com">contact us</a>
}
